import { create } from 'zustand';
import { isStandalone } from './platform';

interface BIPEvent extends Event { prompt(): Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> }
interface InstallState { event: BIPEvent | null; installed: boolean; prompt: () => Promise<boolean> }

export const useInstall = create<InstallState>((set, get) => ({
  event: null,
  installed: isStandalone(),
  async prompt() {
    const e = get().event;
    if (!e) return false;
    await e.prompt();
    const r = await e.userChoice;
    set({ event: null, installed: r.outcome === 'accepted' || get().installed });
    return r.outcome === 'accepted';
  },
}));

export function watchInstall(): void {
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); useInstall.setState({ event: e as BIPEvent }); });
  window.addEventListener('appinstalled', () => useInstall.setState({ installed: true, event: null }));
  window.matchMedia('(display-mode: standalone)').addEventListener('change', (m) => { if (m.matches) useInstall.setState({ installed: true }); });
}
